import {StyleSettings, AvailableStyles} from './data/styles';
import {ToggleGroups, SectionQuantity} from './data/payload';

export interface ModuleSectionState {
    moduleId: number;
    layout: string;
    availableLayouts: string[];
    availableStyles: AvailableStyles;
    fullWidth: boolean;
    isFullWidthAvailable: boolean;
    toggles: ToggleGroups[];
    background: BackgroundSettings;
    manageGroupsActive: boolean;
    configurableGroups: number[];
    innerElementModuleIds: number[];
    loadingMask: boolean;
    style: StyleSettings;
    quantity: SectionQuantity;
    columns: ColumnSettings;
    elementsMenuVisible: boolean;
    backgroundMenuVisible: boolean;
    aviaryOpen: boolean;
    aviaryOptions: AviaryOptions;
}

export interface AviaryOptions {
    moduleId: number;
    origImageUrl: string;
    transformedImageUrl?: string;
    imageMediaType: string;
}

export interface ColumnSettings {
    available: number[];
    active: number;
    loopFit: number;
}

interface ColorRgba {
    red: number;
    green: number;
    blue: number;
    alpha: number;
}

export enum BackgroundType {
    None,
    Color,
    Image,
    Theming
}

export interface ShadingSetting {
    color: [number, number, number];
    alpha: number;
    enabled: boolean;
}

export interface BackgroundSettings {
    type: BackgroundType;
    color?: ColorRgba;
    zone?: number;
    parallax?: boolean;
    imageUrl?: string;
    shading?: ShadingSetting;
    transformedImageUrl?: string;
    origImageUrl?: string;
    imageMediaType?: string;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/state.ts
 **/